var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33984 4.99951H13.3398C15.108 4.99951 16.8036 5.70189 18.0539 6.95213C19.3041 8.20238 20.0065 9.89807 20.0065 11.6662V34.9995C20.0065 33.6734 19.4797 32.4017 18.542 31.464C17.6044 30.5263 16.3326 29.9995 15.0065 29.9995H3.33984V4.99951Z",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 4.99951H26.6667C24.8986 4.99951 23.2029 5.70189 21.9526 6.95213C20.7024 8.20238 20 9.89807 20 11.6662V34.9995C20 33.6734 20.5268 32.4017 21.4645 31.464C22.4021 30.5263 23.6739 29.9995 25 29.9995H36.6667V4.99951Z",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.b109babf1064308c563e680bf3db448a.svg";
export { ForwardRef as ReactComponent };